import { render, staticRenderFns } from "./platformActivityList.vue?vue&type=template&id=59fe1549&scoped=true&"
import script from "./platformActivityList.vue?vue&type=script&lang=js&"
export * from "./platformActivityList.vue?vue&type=script&lang=js&"
import style0 from "./platformActivityList.vue?vue&type=style&index=0&id=59fe1549&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fe1549",
  null
  
)

export default component.exports